module.exports = __webpack_public_path__ + "media/src/images/logos/tiktok-logo-ac95ab6e7130f802a400b4b57d4cadae.png";